import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const importPlanDesign = ({ groupId, spreadsheetUrl }) =>
  call(websocketFetch, 'import_plan_design', {
    group_id: groupId,
    url: spreadsheetUrl,
  });
